import React from 'react';
import { useTranslation } from 'react-i18next';
import { SellerConnectIntakeStatus } from 'models/SellerConnectEngine';
import Tag from 'components/ListingPortfolioCard/components/Tag';
import { INTAKE_STATUS_COLORS, INTAKE_STATUS_LABELS } from '../../data';

type IntakeStatusTagProps = {
  className?: string;
  status: SellerConnectIntakeStatus;
};

const IntakeStatusTag: React.FC<IntakeStatusTagProps> = (props) => {
  const { className, status } = props;

  const { t } = useTranslation();

  return (
    <Tag
      className={className}
      variant={INTAKE_STATUS_COLORS[status]}
      content={t(INTAKE_STATUS_LABELS[status])}
    />
  );
};

export default IntakeStatusTag;
